import type { EventQuery } from '@/gql/myomr'
import { filterSupportedInvitationQuotas } from '@/helpers/invitationQuotas'

type InvitationQuota = NonNullable<EventQuery['eventById']['invitationQuotas']>[number]

export interface GroupedInvitationQuotas {
  personalQuotas: InvitationQuota[]
  partnerCompanyQuotas: InvitationQuota[]
}

export function groupInvitationQuotas(invitationQuotas: InvitationQuota[]): GroupedInvitationQuotas {
  return filterSupportedInvitationQuotas(invitationQuotas).reduce<GroupedInvitationQuotas>(
    (groups, quota) => {
      if (quota.partnerCompany) {
        groups.partnerCompanyQuotas.push(quota)
      } else {
        groups.personalQuotas.push(quota)
      }

      return groups
    },
    { personalQuotas: [], partnerCompanyQuotas: [] },
  )
}
